@if (mensagem || mensagemBloqueio) {
  <div class="alerta">
    @if (mensagem && tipoPacote === 'S') {
      <span>
        <strong> {{ mensagem }}</strong>
      </span>
    }
    @if (mensagemBloqueio && tipoPacote === 'RR') {
      <span class="p-p-3">
        <strong> {{ mensagemBloqueio }}</strong>
      </span>
    }
    @if (controlaAssinatura && mensagem && tipoPacote === 'S') {
      <a
        id="btn-assinar"
        pButton
        label="Assine Agora"
        data-cy="btn-novo"
        routerLink="/assinatura"
      ></a>
    }
  </div>
}
